<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="ep1"> </p>
<p class="EP-1">Grief starts to become indulgent, and it doesn’t serve anyone, and it’s painful. But if you transform it into remembrance, then you’re magnifying the person you lost and also giving something of that person to other people, so they can experience something of that person.</p>
<p class="EPC-1"><span class="ePub-SC">—PATTI SMITH, </span>October 14, 2011, <span class="ePub-I">The New York Times</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph1.vue?13090e44